export default __webpack_public_path__ + "static/media/1.034f1e05.png";